import { ReactElement, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FieldWrapper from '../FieldWrapper';
import useFormInput from '../../../utils/hooks/useFormInput';
import TextField from '../../UI/MDC/TextField/TextField';
import classes from './TextBox.module.scss';

/**
 * Text-based input which is Formik-compliant
 * @param {*} properties needed by TextBox including but not limited to label
 * @returns {ReactElement} Textbox Field component
 */
const TextBox = ({ className, label, onError = null, ...props }) => {
	const {
		field,
		meta: { error, touched, ...meta } = {},
		additionalProps: { labelPosition, ...additionalProps },
	} = useFormInput(props);

	/**
	 * Lifecycle hook on formik prop change. Invokes nullable prop callback when formik field is touched and invalid.
	 *
	 * @function
	 * @returns void. No clean-up performed.
	 */
	useEffect(() => {
		if (onError && touched && error) {
			onError(error);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error, touched]);

	return (
		<FieldWrapper
			label={'Provide ' + label}
			labelPosition={labelPosition}
			field={field}
			meta={meta}
			additionalProps={{
				labelPosition: labelPosition,
				...additionalProps,
			}}
			hideErrorMessage
		>
			<TextField
				{...field}
				{...additionalProps}
				onFocus={e => {
					!!field && !!field.onFocus && field.onFocus(e);
					!!additionalProps.onFocus && additionalProps.onFocus(e);
				}}
				onBlur={e => {
					!!field && !!field.onBlur && field.onBlur(e);
					!!additionalProps.onBlur && additionalProps.onBlur(e);
				}}
				className={classnames([
					classes['form-element__textfield'],
					className,
				])}
				help={additionalProps.help ? additionalProps.help : ' '}
				label={label}
			/>
		</FieldWrapper>
	);
}

TextBox.propTypes = {
	label: PropTypes.string.isRequired,
	onError: PropTypes.func,
};

export default TextBox;